// extracted by mini-css-extract-plugin
export default {"btMenu":"bottomMenu_btMenu__VTq8s","btMenu_item":"bottomMenu_btMenu_item__HGsYf","btMenu_show":"bottomMenu_btMenu_show__AH36t"};